import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../../constants';

export const selectPaperStyles: SxProps<Theme> = {
	boxShadow: '0px 4px 4px rgba(68, 71, 77, 0.08)',
	marginTop: '4px',
	color: 'inherit',
	borderRadius: '8px',
	border: `1px solid ${Colors['grey_2A2A2A']}`,
};

export const selectCheckboxStyles: SxProps<Theme> = {
	// marginLeft: '-13px',
	marginRight: '14px',
	padding: '0',
};
